module.exports = __webpack_public_path__ + "static/media/etisalat.9a16a3e9.png";